module.exports = __webpack_public_path__ + "static/media/carousel1.471a6acd.png";